import { TopSection } from "src/components/_pages/activity/top-section";
import { YakisobaSection } from "src/components/_pages/activity/yakisoba-section";
import { FishingSection } from "src/components/_pages/activity/fishing-section";
import { DivingSection } from "src/components/_pages/activity/diving-section";
import { SaunaSection } from "src/components/_pages/activity/sauna-section";
import { Footer } from "src/components/footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Activity = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <title>石巻マリンヴィレッジ | ACTIVITY</title>
      <article>
        <TopSection />
        <YakisobaSection />
        <FishingSection />
        <DivingSection />
        <SaunaSection />
        <Footer />
      </article>
    </>
  );
};

export default Activity;
